import { render, staticRenderFns } from "./LfsSelectBox.vue?vue&type=template&id=67cb9bab&scoped=true&"
import script from "./LfsSelectBox.vue?vue&type=script&lang=ts&"
export * from "./LfsSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb9bab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
